import {
  Config as EventListenerConfig,
  useEventListener,
} from './EventListener'

interface Config extends EventListenerConfig {
  onScroll: EventListenerConfig['handler']
}

export const useScroll = ({ onScroll, scope = window }: Config) =>
  useEventListener({ event: 'scroll', handler: onScroll, scope })
